import {DashboardChartData, DashboardData} from "./dashboard.data";
import {EntityData} from "@fedeltapointofsale/data-client";

export class DashboardRow extends EntityData<DashboardRow> {
    /**
     * Columns referencing chart Id
     */
    public columns: DashboardChartData[] = [];


    public addNewChart(): DashboardChartData {
        const chart: DashboardChartData = this.newChart();
        this.columns.push(chart);
        return chart;
    }

    public newChart(): DashboardChartData {
        const chart: DashboardChartData = <DashboardChartData> EntityData.create(DashboardChartData);
        chart.chartType = "blank";
        chart.title = "New";
        chart.measures = [];
        return chart;
    }

    hasChartData(): boolean {
        return this.columns.some((col => col.hasChartData()));
    }
}

export class DashboardLayout extends EntityData<DashboardLayout> {
    public rows: DashboardRow[] = [];

    static buildLayout(dashboardData: DashboardData, ignoreBlankCharts: boolean): DashboardLayout {
        const layout: DashboardLayout = <DashboardLayout>EntityData.create(DashboardLayout);
        if (!dashboardData.charts.length) {
            return layout;
        }

        let charts: DashboardChartData[] = dashboardData.charts.slice(0);
        if (ignoreBlankCharts) {
            charts = charts.filter(value => value.chartType !== "blank");
        }
        charts.sort((a, b) => a.layoutRow === b.layoutRow ? a.layoutCol - b.layoutCol : a.layoutRow - b.layoutRow);
        if (!charts.length) {
            return layout;
        }

        let currentRow: number = 0;
        layout.rows.push(<DashboardRow> EntityData.create(DashboardRow));
        charts.forEach((chart) => {
            while (currentRow < chart.layoutRow) {
                if (!ignoreBlankCharts && layout.rows[currentRow].columns.length == 0) {
                    layout.rows[currentRow].addNewChart();
                    layout.rows[currentRow].addNewChart();
                }
                currentRow++;
                const row: DashboardRow = <DashboardRow> EntityData.create(DashboardRow);
                layout.rows.push(row);
            }
            layout.rows[layout.rows.length - 1].columns.push(chart);
        });
        if (!ignoreBlankCharts) {
            while (currentRow < 2) {
                currentRow++;
                const row: DashboardRow = <DashboardRow> EntityData.create(DashboardRow);
                layout.rows.push(row);
                row.addNewChart();
                row.addNewChart();
            }
        }
        return layout;
    }

    hasChartData(): boolean {
        return this.rows.some((row => row.hasChartData()));
    }

}
